const ChatIcon = () => (
  <div>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.59806 19.2597L8.54951 19.25H8.5H8C5.93334 19.25 4.40531 18.9632 3.38387 18.1005C2.38216 17.2545 1.75 15.7482 1.75 13V8C1.75 5.87378 2.30947 4.33263 3.32105 3.32105C4.33263 2.30947 5.87378 1.75 8 1.75H16C18.1262 1.75 19.6674 2.30947 20.6789 3.32105C21.6905 4.33263 22.25 5.87378 22.25 8V13C22.25 15.1262 21.6905 16.6674 20.6789 17.6789C19.6674 18.6905 18.1262 19.25 16 19.25H15.5C15.2432 19.25 15.0411 19.3797 14.9159 19.5299L14.9077 19.5397L14.9 19.55L13.4008 21.549C13.4008 21.549 13.4007 21.549 13.4007 21.5491C13.022 22.0512 12.5123 22.31 12 22.31C11.4877 22.31 10.978 22.0512 10.5993 21.5491C10.5993 21.549 10.5992 21.549 10.5992 21.549L9.1 19.55C9.03815 19.4675 8.96434 19.4182 8.93391 19.3986C8.89344 19.3725 8.85308 19.3517 8.81972 19.336C8.76097 19.3085 8.67787 19.2757 8.59806 19.2597ZM11 21.25L11.0021 21.2528C11.2455 21.5727 11.5927 21.795 12 21.795C12.4073 21.795 12.7545 21.5727 12.9979 21.2528L13 21.25L14.5 19.25C14.7356 18.9359 15.1074 18.75 15.5 18.75H16C17.8583 18.75 19.325 18.3172 20.3211 17.3211C21.3172 16.325 21.75 14.8583 21.75 13V8C21.75 6.14167 21.3172 4.67505 20.3211 3.67895C19.325 2.68285 17.8583 2.25 16 2.25H8C6.14167 2.25 4.67505 2.68285 3.67895 3.67895C2.68285 4.67505 2.25 6.14167 2.25 8V13C2.25 15.2821 2.63315 16.7948 3.65731 17.6955C4.66408 18.5808 6.16081 18.75 8 18.75H8.5C8.8516 18.75 9.28416 18.9651 9.50069 19.2509C9.50085 19.2511 9.50101 19.2513 9.50117 19.2516L11 21.25Z"
        fill="#9E9E9E"
        stroke="#9E9E9E"
      />
      <path
        d="M12 11.5C11.7194 11.5 11.5 11.2771 11.5 11C11.5 10.7261 11.7261 10.5 12 10.5C12.2739 10.5 12.5 10.7261 12.5 11C12.5 11.2771 12.2806 11.5 12 11.5Z"
        fill="#9E9E9E"
        stroke="#9E9E9E"
      />
      <path
        d="M16 12C15.44 12 15 11.55 15 11C15 10.45 15.45 10 16 10C16.55 10 17 10.45 17 11C17 11.55 16.56 12 16 12Z"
        fill="#9E9E9E"
      />
      <path
        d="M8 12C7.44 12 7 11.55 7 11C7 10.45 7.45 10 8 10C8.55 10 9 10.45 9 11C9 11.55 8.56 12 8 12Z"
        fill="#9E9E9E"
      />
    </svg>
  </div>
);
export default ChatIcon;
